import React, { useContext, useState } from 'react';
import { Col, Container, Form, Image, Row, Spinner } from 'react-bootstrap';
import ImgLogin from './../assets/img/login.png';
import Titulo from '../elements/Titulo';
import Btn from '../elements/Btn';
import { ContextAlert } from '../context/ContextAlert';
import { useNavigate } from 'react-router-dom';
import { auth } from '../firebase/firebaseConfig';
import { signInWithEmailAndPassword } from "firebase/auth";
import Alert from './Alert';
import { dotoniwoofApi } from '../api/dotoniwooApi';
import { getActionsByRoleHierarchical } from '../services/actionApi';
import { useAuth } from '../context/AuthContext';
import { useBranding } from '../context/BrandingContext';
import { Helmet } from 'react-helmet';
import './ModernLogin.css';



const Login = () => {

    const navigate = useNavigate();
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [loading, setLoading] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const { handleShow, alert, changeAlert } = useContext(ContextAlert);
    const { companyName, tagline, loginImageUrl } = useBranding();

    const handleChange = (e) => {
        switch (e.target.name) {
            case 'email':
                setEmail(e.target.value);
                break;
            case 'password':
                setPassword(e.target.value);
                break;
            default:
                break;
        }
    }


    const getRol = async (email, callback) => {
        const { data } = await dotoniwoofApi.get(`user.php/${email}`);
        const userData = data?.data ? data.data : (data?.message?.[0]);
        const roleId = userData?.id_role;
        if (roleId != null) callback(roleId);
    }


    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        
        const regularExpresion = /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/;

        if (!regularExpresion.test(email)) {
            setLoading(false);
            handleShow();
            changeAlert(
                {
                    type: "danger",
                    message: "El formato del correo es invalido",
                    header: "Error"
                }
            )
            return;
        }

        if (email === '' || password === '') {
            setLoading(false);
            handleShow();
            changeAlert(
                {
                    type: "danger",
                    message: "Todos los campos deben estar completos",
                    header: "Error"
                }
            )
            return;
        }

        try {

            await signInWithEmailAndPassword(auth, email, password);
            getRol(email, async (roleId) => {
                // Guardar role_id en localStorage inmediatamente
                localStorage.setItem('role_id', roleId);
                
                const { ok, data } = await getActionsByRoleHierarchical(roleId);
                if (ok && (data?.code === 200 || data?.data)) {
                    const menu = data.data ?? data.message ?? [];
                    localStorage.setItem('menu', JSON.stringify(Array.isArray(menu) ? menu : []));
                }
            }
            );
            navigate('/');
        } catch (error) {
            console.log(error);
            setLoading(false);
            let message;
            switch (error.code) {
                case 'auth/invalid-password':
                    message = 'Contraseña invalida'
                    break;
                case 'auth/invalid-credential':
                    message = 'Credenciales invalidas'
                    break;
                default:
                    message = "Ocurrio un error en la autenticación"
                    break;
            }


            handleShow();
            changeAlert(
                {
                    type: "danger",
                    message: message,
                    header: "Error"
                }
            )
        }
    }



    return (
        <>
            <Helmet>
                <title>Ingresar - {companyName}</title>
            </Helmet>
            
            <div className="modern-login-container">
                {/* Animated background */}
                <div className="login-background">
                    <div className="floating-shapes">
                        <div className="shape shape-1"></div>
                        <div className="shape shape-2"></div>
                        <div className="shape shape-3"></div>
                        <div className="shape shape-4"></div>
                        <div className="shape shape-5"></div>
                    </div>
                </div>

                <Container fluid className="modern-login-content">
                    <Row className="justify-content-center align-items-stretch h-100 g-0 m-0 flex-column flex-md-row">
                        {/* Image Column */}
                        <Col lg={6} md={6} xs={12} className="image-column order-1 order-md-1">
                            <div className="image-wrapper">
                                <div>
                                    <Image 
                                        src={loginImageUrl || ImgLogin} 
                                        className="login-image" 
                                        alt={`${companyName} Login`}
                                        onError={(e) => { e.target.src = ImgLogin; }}
                                    />
                                    <div className="image-overlay">
                                        <div className="welcome-text">
                                            <h1 className="brand-name">{companyName}</h1>
                                            <p className="brand-tagline">{tagline}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Col>

                        {/* Form Column */}
                        <Col lg={6} md={6} xs={12} className="form-column order-2 order-md-2">
                            <div className="login-form-wrapper">
                                <div className="login-card">
                                    <div className="login-card-header">
                                        <div className="logo-icon">🐕</div>
                                        <Titulo>Inicia tu sesión</Titulo>
                                        <p className="login-subtitle">Accede a tu panel de administración</p>
                                    </div>

                                    <Form onSubmit={handleSubmit} className="modern-login-form">
                                        {/* Email Field */}
                                        <Form.Group className="mb-4 modern-form-group">
                                            <Form.Label className="modern-label">
                                                <i className="fas fa-envelope me-2"></i>
                                                Correo Electrónico
                                            </Form.Label>
                                            <div className="input-wrapper">
                                                <i className="fas fa-user input-icon"></i>
                                                <Form.Control
                                                    name='email'
                                                    type="text"
                                                    placeholder="tu@email.com"
                                                    value={email}
                                                    onChange={handleChange}
                                                    className="modern-input"
                                                    disabled={loading}
                                                />
                                            </div>
                                        </Form.Group>

                                        {/* Password Field */}
                                        <Form.Group className="mb-4 modern-form-group">
                                            <Form.Label className="modern-label">
                                                <i className="fas fa-lock me-2"></i>
                                                Contraseña
                                            </Form.Label>
                                            <div className="input-wrapper">
                                                <i className="fas fa-key input-icon"></i>
                                                <Form.Control
                                                    name='password'
                                                    type={showPassword ? "text" : "password"}
                                                    placeholder="••••••••"
                                                    value={password}
                                                    onChange={handleChange}
                                                    className="modern-input"
                                                    disabled={loading}
                                                />
                                                <button
                                                    type="button"
                                                    className="toggle-password"
                                                    onClick={() => setShowPassword(!showPassword)}
                                                    disabled={loading}
                                                >
                                                    <i className={`fas ${showPassword ? 'fa-eye-slash' : 'fa-eye'}`}></i>
                                                </button>
                                            </div>
                                        </Form.Group>

                                        {/* Submit Button */}
                                        <button
                                            type="submit"
                                            className="modern-submit-btn"
                                            disabled={loading}
                                        >
                                            {loading ? (
                                                <>
                                                    <Spinner
                                                        as="span"
                                                        animation="border"
                                                        size="sm"
                                                        role="status"
                                                        aria-hidden="true"
                                                        className="me-2"
                                                    />
                                                    Iniciando sesión...
                                                </>
                                            ) : (
                                                <>
                                                    <i className="fas fa-sign-in-alt me-2"></i>
                                                    Iniciar Sesión
                                                </>
                                            )}
                                        </button>

                                        {/* Footer Info */}
                                        <div className="login-footer">
                                            <div className="security-badge">
                                                <i className="fas fa-shield-alt me-2"></i>
                                                Conexión segura
                                            </div>
                                        </div>
                                    </Form>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Container>
                
                <Alert message={alert.message} type={alert.type} header={alert.header}></Alert>
            </div>
        </>
    );
}

export default Login;